/**
 * Cognito 認証で得た情報を他ページでも共通利用するためのヘルパー
 * index.js の AuthProvider 配下であれば、どのコンポーネントからも useAuth() で認証情報を参照可能
 */

// Display Name が "ローマ字／漢字／英字" 形式の場合、漢字部分（2番目）だけを返す
// custom:displayname の区切りは全角 "／" (U+FF0F)
export const getDisplayNameKanji = (rawDisplayName) => {
  if (rawDisplayName == null || typeof rawDisplayName !== "string") return "";
  const displayName = String(rawDisplayName).trim();
  if (!displayName) return "";
  const parts = displayName.split("\uFF0F").map((p) => p.trim()).filter(Boolean);
  return parts.length >= 2 ? parts[1] : "";
};

/**
 * profile から表示用ユーザー名（漢字優先）を取得
 * @param {object} profile - auth.user.profile
 * @returns {string}
 */

// 表示用ユーザー名（認証時）。Cognito の custom:displayname（ローマ字／漢字／英字）から漢字部のみを表示
export const getDisplayUserName = (profile) => {
  if (!profile) return "";
  const rawDisplayName = profile["custom:displayname"] ?? "";
  const kanjiPart = getDisplayNameKanji(rawDisplayName);
  return kanjiPart
    //|| profile.name
    //?? profile.preferred_username
    //?? profile["custom:employeeid"]
    ?? "";
};
